import * as React from 'react';
import { Message, ToolCallState } from './types';
import AiChatMessage from './AiChatMessage';
import AiChatSuggestions from './AiChatSuggestions';
import AiChatQuickActions from './AiChatQuickActions';
import { ChatContainer } from './ChatContainer';

type Props = {
  messages: Message[];
  isLoading: boolean;
  activeToolName: string | null;
  pendingConfirm: ToolCallState | null;
  onConfirm: (toolId: string) => void;
  onCancel: (toolId: string) => void;
  onSuggestionClick: (text: string) => void;
  onNavigate: (route: string) => void;
  onRetry?: () => void;
  onFeedback?: (
    messageId: string,
    rating: 'up' | 'down',
    comment?: string,
  ) => void;
};

const AiChatMessages: React.FC<React.PropsWithChildren<Props>> = ({
  messages,
  isLoading,
  activeToolName,
  pendingConfirm,
  onConfirm,
  onCancel,
  onSuggestionClick,
  onNavigate,
  onRetry,
  onFeedback,
}) => {
  if (messages.length === 0) {
    return <AiChatSuggestions onSuggestionClick={onSuggestionClick} />;
  }

  const lastMessage = messages[messages.length - 1];
  const showQuickActions =
    lastMessage.role === 'assistant' && lastMessage.quickActions.length > 0;

  return (
    <ChatContainer className="flex-grow-1">
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5rem',
          padding: '0.75rem 0',
        }}>
        {messages.map((msg) => (
          <AiChatMessage
            key={msg.id}
            message={msg}
            pendingConfirm={pendingConfirm}
            isStreaming={isLoading && msg.id === lastMessage.id}
            activeToolName={activeToolName}
            onConfirm={onConfirm}
            onCancel={onCancel}
            onNavigate={onNavigate}
            onRetry={onRetry}
            onFeedback={onFeedback}
          />
        ))}

        {showQuickActions && (
          <AiChatQuickActions
            quickActions={lastMessage.quickActions}
            onNavigate={onNavigate}
            onInlinePrompt={onSuggestionClick}
          />
        )}
      </div>
    </ChatContainer>
  );
};

export default AiChatMessages;
